import { onboarding } from '../types';
import auth from './auth';

const INITIAL_STATE = {
    error: undefined
}

const onboardingreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case onboarding.SAVE_CUSTOMER_ONBOARDING_DETAILS_SUCCESS:
            return {
                ...state,
                customerOnboardingStatus: {
                    is_pending: false,
                }
            }
        case onboarding.SAVE_CUSTOMER_ONBOARDING_DETAILS_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        case auth.RESET_ONBOARDING_STORE_SUCCESS:
            return INITIAL_STATE    

        default:
            return {
                ...state
            }
    }
}

export default onboardingreducer